module.exports = __webpack_public_path__ + "img/mm-spr.4ebfde51.svg";